<lib-back-button
  class="back-button"
  label="Back to all Contracts"
  (clickEvent)="goBackToRDataRecordsPage()"
>
</lib-back-button>
<app-page-heading pageTitle="Contract Details"> </app-page-heading>

<app-page-well>
  <lib-rdata-details [contractDetails]="contractDetails | async"></lib-rdata-details>
</app-page-well>